import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import POIMap from '@bd/bdui-poimap';
import { css } from '@bd/bdui-styles/emotion';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuAbout from '../../components/MenuAbout';
import PageIntroBanner from '../../components/PageIntroBanner';
import PageSection from '../../components/PageSection';
import PageSectionContent from '../../components/PageSectionContent';

const POIMapStyles = css`
  position: relative;
  height: calc(100vh - 115px);
  width: 100%;
  z-index: 0;
  @media (min-width: 992px) {
    height: calc(100vh - 115px);
    width: auto;
    flex-grow: 1;
  }
  .POIMap_wrapper {
    display:flex;
    flex-wrap: wrap;
  }
  .POIMap_inner {
    width: 100%;
    height: calc(50vh - 115px);
    background-color: #F5F5F5;
    overflow: hidden;
    overflow-y: scroll;
    padding: 15px;
    order: 2;
    @media (min-width: 992px) {
      height: calc(100vh - 115px);
      width: 33.333%;
      order: 1;
      padding: 30px;
    }
  }
  .POIMap_categories {
    list-style: none;
    padding: 0;
    text-align: left;
    li {
      border-bottom: 1px solid #CCCCCC;
      padding: 0 15px;
      @media (min-width: 992px) {
        padding: 0 30px;
      }
      a {
        cursor: pointer;
        color: #333333;
        font-size: 15px;
        font-weight: 700;
        letter-spacing: 2px;
        text-transform: uppercase;
        display: block;
        padding: 10px 0;
        @media (min-width: 992px) {
          font-size: 18px;
        }
      }
    }
    img {
      margin: 0 10px 0 0;
    }
    ul {
      list-style: none;
      padding: 0 0 10px 0;
      li {
        font-size: 15px;
        font-weight: 600;
        border: 0;
        span {
          padding: 12px 0;
          cursor: pointer;
          display: block;
        }
      }
    }
  }
  .POIMap_mapWrapper {
    position: relative;
    z-index: 0;
    width: 100%;
    height: calc(50vh - 115px);
    order: 1;
    @media (min-width: 992px) {
      height: calc(100vh - 115px);
      width: 66.666%;
      order: 2;
    }
    .leaflet-container {
      width: 100%;
      height: calc(50vh - 115px);
      @media (min-width: 992px) {
        height: calc(100vh - 115px);
      }
    }
  }
  .leaflet-container {
    width: 100%;
    height: calc(50vh - 115px);
    @media (min-width: 992px) {
      height: calc(100vh - 115px);
    }
  }
  .leaflet-popup-content-wrapper {
    .CommunityCard_wrapper {
      width: 100% !important;
    }
    .CommunityCard_inner {
      flex-direction: column !important;
    }
    .CommunityCard_mapButton {
      display: none !important;
    }
    .CommunityCard_detailButton {
      width: 100% !important;
    }
    .CommunityCard_buttonWrapper {
      margin: 0 !important;
    }
    .CommunityCard_priceValue {
      padding: 10px 8px !important;
    }
  }
  .poimap {
    .map-wrapper {
      width: 100%;
      height: 100%;
    }
  }
`;

function AboutTheArea({ page, communities }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader
        h1={`${get(page, 'meta.name')}`}
        background={get(page, 'page_image.contentUrl')}
      />
      <MenuAbout />
      <PageIntroBanner
        headline={get(page, 'page_intro_banner[0].headline')}
        body={get(page, 'page_intro_banner[0].text')}
      />
      <div className="container">
        <POIMap community={communities[0]} className={POIMapStyles} />
      </div>
      <PageSection fullwidth>
        {
          page.sections.map(item => (
            <PageSectionContent
              alternating
              key={item.title}
              preTitle={item.pre_title}
              title={item.title}
              body={item.body}
              media={
                <div
                  className="ContentBanner_resultMediaInner"
                  style={{ backgroundImage: `url('${buildThumbnailUrl(get(item, 'image.contentUrl'), { width: 1200, height: 1200 })}')` }}
                />
              }
            />
          ))
        }
      </PageSection>
    </PageWrapper>
  );
}

AboutTheArea.propTypes = {
  page: PropTypes.object.isRequired,
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData({
  page: 'about_the_area',
  communities: true,
})(AboutTheArea);



// WEBPACK FOOTER //
// ./src/pages/AboutTheArea/index.js